'use client'

import {BlogNotFound} from '@/components/blog/BlogNotFound'

// The listings under /blog resolve here, the articles in (static)/blog - both show the same 404.
export default function NotFound() {
  return <BlogNotFound />
}
